import { QuestionCircleOutlined } from '@ant-design/icons';
import { SubscriptionStatus } from '@prisma/client';
import { TagProps } from 'antd';

import { Theme } from '@app/web-components';

export const useSubscriptionStatusTag = () => {
  const { token } = Theme.useToken();

  const getProps = (status: SubscriptionStatus): TagProps => {
    switch (status) {
      case SubscriptionStatus.QUEUED:
        return { children: 'Queued', color: '#8c8c8c' };
      case SubscriptionStatus.PENDING:
        return {
          children: 'Pending',
          color: token['bright-warning'],
          icon: (
            <a
              href={'https://wiki.ith.intel.com/display/SAAFWIKI/How+to+see+the+approver%28s%29+of+AGS+or+IEM+requests'}
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: '0.5em' }}
            >
              <QuestionCircleOutlined />
            </a>
          ),
          style: { color: token['carbon-shade-2'] },
        };
      case SubscriptionStatus.NOT_ACQUIRED:
        return { children: 'Not Acquired', color: token['bright-error'] };
      case SubscriptionStatus.ERROR:
        return { children: 'Error', color: token['bright-error'] };
      case SubscriptionStatus.COMPLETED:
        return { children: 'Completed', color: token['bright-success'] };
    }
  };

  return { getProps };
};
